import API from '../dataApi';

// -- Accounting: Opening Balance -----------------------------------------------
export const getOpeningBalance = (yearId) => API.get(`/opening-balance/${yearId}`);
export const updateOBAssets = (yearId, data) => API.put(`/opening-balance/${yearId}/assets`, data);
export const updateOBCategories = (yearId, data) => API.put(`/opening-balance/${yearId}/categories`, data);
export const updateOBOfferings = (yearId, data) => API.put(`/opening-balance/${yearId}/offerings`, data);
export const updateOBPledges = updateOBOfferings;
export const lockOpeningBalance = (yearId) => API.post(`/opening-balance/${yearId}/lock`);
export const unlockOpeningBalance = (yearId) => API.post(`/opening-balance/${yearId}/unlock`);
export const confirmOpeningBalance = lockOpeningBalance;
export const revertOpeningBalance = unlockOpeningBalance;
export const getOBBalanceCheck = (yearId) => API.get(`/opening-balance/${yearId}/balance-check`);
export const getOBAmendments = (yearId) => API.get(`/opening-balance/${yearId}/amendments`);
